// extracted by mini-css-extract-plugin
export default {"wrapper":"checkbox__wrapper","wrapper--checked":"checkbox__wrapper--checked"};